<template>
  <!-- PAGE CONTENT BEGINS -->
  <div class="">
    <el-container>
      <el-main>
        <el-button size="small"  style="margin-right: 8px" type="primary"  plain icon="el-icon-plus" @click="openOff">新增公众号</el-button>
        <el-button size="small" @click="loadList(1)" type="primary"  plain icon="el-icon-search">搜索</el-button>
        <el-table :data="tableData" border :row-style="{height:'40px',textAlign:'center'}"
                  :cell-style="{height:'5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" min-width="10%">
          </el-table-column>
          <el-table-column prop="id" label="ID" width="200">
          </el-table-column>
          <el-table-column prop="appId" label="appId" width="200">
          </el-table-column>
          <el-table-column prop="appSecret" label="appSecret" width="300">
          </el-table-column>
          <el-table-column prop="companyId" label="公众号名称" width="200">
          </el-table-column>
          <el-table-column prop="agentId" label="代理商" width="180">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="200">
          </el-table-column>
          <el-table-column label="操作" min-width="200">
            <template slot-scope="scope">
              <!--<el-button type="primary" plain size="small" @click.native="lookEtc(scope.row)">查看粉丝
              </el-button>-->
              <el-button type="primary" plain size="small" @click.native="edit(scope.row)">编辑
              </el-button>
              <!--<el-dropdown trigger="click" split-button type="primary" class="q-ml-lg" size="small">
                <span>更多操作</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editMenu(scope.row.appId)">设置菜单
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="lookEtc(scope.row.appId)">查看粉丝
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="openSelinx(scope.row.appId)">客服管理
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="edit(scope.row.appId)">编辑
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="loadList" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>

    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="class_dialog_hospital" width="40%">
      <el-form :rules="rules" ref="appData" :model="appData" style="padding:0px 20px;">
        <!--<el-form-item label="代理商">
          <el-select style="width: 100%" filterable allow-create default-first-option v-model="appData.agentId" placeholder="请选择代理商">
            <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item v-if="appData.id" label="ID" prop="id">
          <el-input v-model="appData.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="公众号名称" prop="companyId">
          <el-input v-model.trim="appData.companyId" placeholder="请选择公众号名称"></el-input>
        </el-form-item>
        <el-form-item label="appId" prop="appId">
          <el-input v-model.trim="appData.appId" placeholder="请选择appId"></el-input>
        </el-form-item>
        <el-form-item label="Token" prop="appToken">
          <el-input v-model.trim="appData.appToken" placeholder="请选择Token"></el-input>
        </el-form-item>
        <el-form-item label="appSecret" prop="appSecret">
          <el-input show-password v-model.trim="appData.appSecret" placeholder="请选择appSecret"></el-input>
        </el-form-item>
        <el-form-item label="商户号" prop="mchId">
          <el-input v-model.trim="appData.mchId" placeholder="请选择商户号"></el-input>
        </el-form-item>
        <el-form-item label="支付密钥" prop="paternerKey">
          <el-input show-password v-model.trim="appData.paternerKey" placeholder="请选择支付密钥"></el-input>
        </el-form-item>
        <el-form-item label="接入地址" prop="indexUrl">
          <el-input v-model.trim="appData.indexUrl" placeholder="请选择接入地址"></el-input>
        </el-form-item>
        <el-form-item label="微信回调地址" prop="backUrl">
          <el-input v-model.trim="appData.backUrl" placeholder="请选择微信回调地址"></el-input>
        </el-form-item>
        <el-form-item label="扫码回调地址" prop="nativeUrl">
          <el-input v-model.trim="appData.nativeUrl" placeholder="请选择扫码回调地址"></el-input>
        </el-form-item>
        <el-form-item v-if="isTxt" label="授权文件名" prop="authTxt">
          <el-input disabled :value="appData.authTxt"></el-input>
        </el-form-item>
      </el-form>
      <!--<div style="font-size:15px;">上传授权文件:<sapn style="color:red;font-weight: 700;">(*上传 .txt 格式 *)</sapn>
        <span v-if="isTxt" style="margin-left: 5%;color: red">{{appData.authTxt}}&ndash;&gt;>>已选择</span>
      </div>-->
      <div id="div" style="margin:15px 0px;">
        <el-button type="primary" plain size="small" @click="uploadFile" style="margin-right:10px">选择文件</el-button>
        <el-button :disabled="showBtnEdit" type="primary" plain size="small" @click="fileEdit" style="margin-left:10px">点我上传</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="info" plain @click="dialogFormVisible=flase">取 消</el-button>
        <el-button size="small" type="primary" plain @click="editConfig('appData',appData)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import Pagination from '../../../components/pagination'
import tools from '../../../utils/tools'
export default {
  name: 'menu_list',
  components: { Pagination },
  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.loadList(1)
  },
  data() {
    return {
      isTxt: false,
      title:'',
      maxHeight: 500,
      dialogFormEdit: false,
      //agents: [],
      showBtn: false,
      showBtnEdit: false,
      file: '',
      tableData: [],

      appData: {
        appId: '',
        appToken: '',
        appSecret: '',
        paternerKey: '',
        companyId: '',
        mchId: '',
        indexUrl: '',
        backUrl: '',
        nativeUrl: '',
        authTxt: ''
      },
      rules: {
        appId: [{ required: true, message: '请输入公众号的appId', trigger: 'blur' }],
        appToken: [{ required: true, message: '请输入接入TOKEN', trigger: 'blur' }],
        appSecret: [{ required: true, message: '请输入公众号的密钥', trigger: 'blur' }],
        paternerKey: [{ required: true, message: '支付密钥长度32位', trigger: 'blur' }],
        companyId: [{ required: true, message: '请输入公众号名称', trigger: 'blur' }],
        mchId: [{ required: true, message: '请输入微信商户号', trigger: 'blur' }],
        indexUrl: [{ required: true, message: '请输入公众号接入地址', trigger: 'blur' }],
        backUrl: [{ required: true, message: '请输入微信支付回调地址', trigger: 'blur' }],
        nativeUrl: [{ required: true, message: '请输入微信扫码回调地址', trigger: 'blur' }],
        authTxt: [{ required: true, message: '请上传授权文件', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      wxConfig: {},
      offaccountJs: require('../../../api/offaccount')
    }
  },
  methods: {
    openOff() {
      let _this = this
      _this.title = "新增公众号"
      _this.appData ={}
      _this.dialogFormVisible = true
    },
    edit(row) {
      let _this = this
      _this.title="编辑公众号"
      _this.appData = row
      _this.dialogFormVisible = true

      _this.$ajax.get(process.env.VUE_APP_SERVER + '/wechat/wx/getAppIdData/' + appId).then(res => {
        if (res.data.code === '0') {
          _this.appData = res.data.data
        } else {
          _this.$notify.success(res.data.msg)
        }
      })
    },

    cancleEdit() {
      let _this = this
      _this.dialogFormVisible = false
    },
    startFile() {
      let _this = this
      _this.showBtn = true
      if (_this.$check.checkIsNull(_this.file)) {
        _this.$notify.error('请选择文件')
        _this.showBtn = false
        return
      }
      //上传
      let formData = new FormData()
      formData.append('file', _this.file)
      _this.$ajax
        .post(process.env.VUE_APP_SERVER + '/wechat/wx/up-Au-txt', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          if (res.data.code === '0') {
            _this.$notify.success(res.data.data)
            _this.showBtn = true
          }
        })
        .catch(err => {
          _this.$notify.error(res.data.msg)
          _this.showBtn = true
        })
    },

    fileEdit() {
      let _this = this
      _this.showBtnEdit = true
      if (_this.$check.checkIsNull(_this.file)) {
        _this.$alert('请选择文件')
        _this.showBtnEdit = false
        return
      }
      //上传
      let formData = new FormData()
      formData.append('file', _this.file)
      _this.offaccountJs.uploadAuthTxt(formData)
        .then(res => {
          if (res.data.code === '0') {
            _this.$alert(res.data.data)
            _this.showBtnEdit = true
          }
        })
        .catch(err => {
          _this.$alert(res.data.msg)
          _this.showBtnEdit = true
        })
    },
    uploadFile() {
      let _this = this
      let html = $('<input id="stUp" type="file" style="display: none"/>')
      html.click()
      let filename
      let file
      html.change(function () {
        file = html[0].files[0]
        filename = html[0].files[0].name
        _this.appData.authTxt = filename
        let extName = filename.substring(filename.lastIndexOf('.') + 1)
        if (extName !== 'txt') {
          _this.$alert('上传格式错误')
          return false
        }
        _this.file = file
        if(_this.file!=null){
          _this.isTxt = true
        }

      })

    },

    openSelinx(appId) {
      let _this = this
      _this.$router.push({
        name: '客服管理',
        params: { appId: appId }
      })
    },
    lookEtc(appId) {
      let _this = this
      _this.$router.push({
        name: '查看粉丝',
        params: { appId: appId }
      })
    },
    editMenu(appId) {
      let _this = this
      _this.$router.push({
        name: '设置菜单',
        params: { appId: appId }
      })
    },
    addConfig(formName) {
      let _this = this
      if (_this.$check.checkIsNull(_this.file)) {
        _this.$notify.error('请选择文件')
        _this.showBtn = false
        return
      }
      if (_this.$check.checkIsNull(_this.rulesForm.agentId)) {
        _this.$notify.error('请选择代理商')
        return
      }
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.$ajax.post(process.env.VUE_APP_SERVER + '/wechat/wx/addConfig', _this.rulesForm).then(res => {
            if (res.data.code === '0') {
              _this.$notify.success(res.data.data)
              _this.dialogFormVisible = false
              _this.loadList(1)
            } else {
              _this.$notify.error(res.data.msg)
              _this.dialogFormVisible = false
              _this.loadList(1)
            }
          })
        } else {
          return false
        }
      })
    },
    loadList(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      let data={
        current: page,
        size: _this.$refs.pagination.size
      }
      _this.offaccountJs.getWxConfigList(data)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },

    editConfig(formName,row) {
      let _this = this
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.offaccountJs.editConfig(_this.appData).then(res => {
            if (res.data.code === '0') {
              _this.$alert(res.data.data)
              _this.dialogFormVisible = false
              _this.loadList(1)
            } else {
              _this.$alert(res.data.msg)
              _this.dialogFormVisible = false
              _this.loadList(1)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }

  ::v-deep .el-button-group .el-button {
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }


/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
/deep/.el-table .el-table__cell {
  padding: 0px !important;
}
/deep/thead.has-gutter {
  height: 40px;
}

</style>
